import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import LandingJazzCashScreen from "./screens/LandingJazzCashScreen";
import JazzCashFallbackScreen from "./screens/JazzCashFallBackScreen";
import TagManager from "react-gtm-module";
import { gtmId } from "../utils/config";
import { fetchApiPostAuth } from "../utils/FetchApi";
import { ApiName } from "../Constant/ApiName";
import Loader from "../components/Loader";

const LandingJazzCashRoutes = () => {
  useEffect(() => {
    const tagManagerArgs = { gtmId };
    TagManager.initialize(tagManagerArgs);
  }, []);
  const [jwtToken, setJwtToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const RedirectToMainApp = () => {
    useEffect(() => {
      window.location.replace("/home");
    }, []);
    return <></>;
  };

  useEffect(() => {
    generateToken();
  }, []);

  const generateToken = async () => {
    try {
      let data: any = {
        username: process.env.REACT_APP_UserName,
        password: process.env.REACT_APP_Password,
      };
      const response = await fetchApiPostAuth(ApiName.generateGwtToken, data);

      if (response.success === true) {
        global.authToken = response.result;
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Jwt token" + error);
    } finally {
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return <Loader fullScreen />;
  }
  return (
    <Routes>
      <Route path="/landing" element={<LandingJazzCashScreen />} />
      <Route path="/jc" element={<JazzCashFallbackScreen />} />
      <Route path="/*" element={<RedirectToMainApp />} />
    </Routes>
  );
};

export default LandingJazzCashRoutes;
